<template>
  <div
    class="single-blog-card card border-0 shadow-sm rounded overflow-hidden"
    :class="{ 'gray-light-bg': isGray }"
  >
    <div class="blog-img position-relative">
      <div style="width: 100%; aspect-ratio: 1/1; object-fit: cover">
        <img
          :src="imageUrl"
          alt="blog"
          style="width: 100%; aspect-ratio: 1/1; object-fit: cover"
        />
      </div>
      <div class="meta-date">
        <strong>{{ day }}</strong>
        <small>{{ month }}</small>
      </div>
    </div>
    <div class="card-body">
      <h3 class="h5 mb-2 card-title line-clamp-1">
        {{ title }}
      </h3>
      <div class="line-clamp-3">
        {{ desc }}
      </div>
      <!-- <editor
        v-model="sortenDesc"
        class="card-text"
        mode="viewer"
      /> -->
      <a
        :href="'/announcement/' + id"
        class="detail-link"
      >
        Read more
        <span class="ti-arrow-right"></span>
      </a>
    </div>
  </div>
</template>

<script>
// import { Editor } from 'vuetify-markdown-editor'

export default {
  name: 'SmallBlogItem',
  // components: { Editor },
  props: {
    id: {
      type: Number,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    day: {
      type: Number,
      required: true
    },
    month: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    desc: {
      type: String,
      required: true
    },
    isGray: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sortenDesc() {
      if (this.desc.length > 100) {
        return this.desc.slice(0, 100) + '...'
      }

      return this.desc
    }
  }
}
</script>

<style scoped>
:deep(.single-blog-card) {
  min-width: 17rem !important;
}

:deep(.card-text) {
  padding: 0 !important;
  max-width: 100ch;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: wrap;
}

.line-clamp-1 {
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line-clamp-3 {
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
